export enum DynamicProperties {
  Organization = "organization_name",
  Coc = "CoC number",
  Vat = "VAT number",
  Newsletter = "newsletter",
}
